import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";
import { Permissions } from "./Permissions";
import { PermissionsHeader } from "./PermissionsHeader";
import JSONViewer from "../../../../../components/json_viewer/JSONViewer";

@inject("permissionsController")
@observer
export class SidePanel extends React.Component<{
  permissionsController?: PermissionsController;
}> {
  public render() {
    return (
      <div className="bg-white">
        <PermissionsHeader />
        <Permissions />
        <JSONViewer ref={(ref) => (this.props.permissionsController.jsonViewer = ref)} />
      </div>
    );
  }
}
